import { uniqGameId } from '../providersData/GameCatalog/uniqGameId'
import { Providers } from '../types/configuration'

const sg = (provider: string, gameId: string) => uniqGameId(Providers.SoftGaming, provider, gameId)

export const OKTOBERFEST_CATEGORY = 'oktoberfest'

export const oktoberfestGames: string[] = [
  'vs20octobeer',
  sg('spinomenal', 'SlotMachine_BeerCollection-10E'),
  sg('spinomenal', 'SlotMachine_SpinningBeers'),
  'thunderkick:DionysusGoldenFeast_tk',
  'oktoberfest_original',
  sg('bgaming', 'CloverBonanza'),
  'platipus:coinfest',
  'thunderkick:TheGoldenPotPints',
  sg('bgaming', 'BeerBonanza'),
  'evoplay:PiggyfestBonanza',
  'vs10strawberry',
  sg('spinomenal', 'SlotMachine_BeerCollection-40E'),
  'avatarux:BlondesAndBeers',
  sg('spinomenal', 'SlotMachine_IrishTreasures-LF'),
  'onlyplay:LuckyBarrel',
  sg('platipus', 'catchtheleprechaun'),
  sg('spinomenal', 'SlotMachine_BeerCollection-20E'),
  'yggdrasil:3LuckyLeprechauns',
  sg('spinomenal', 'SlotMachine_BeerOclock'),
  'evoplay:EmeraldBrewer',
]
